import React, {Fragment} from 'react';

import {getSpoonerism, getSpoonerismAdult} from '../../constants/tests.js';
import StopWatch from '../../components/StopWatch';
import AdminTestPanel from '../../components/AdminTestPanel';
import AdminReadyButton from '../../components/AdminReadyButton';
import {updateStepData} from '../../api';
import strings from '../../strings';
import CountDown from '../../components/CountDown';

class SpoonerismAdmin extends AdminTestPanel {
	constructor(props) {
		super(props, {
			stopOnConsecutiveErrors: true,
			maxConsecutiveErrors: 5,
			enableHotkeys: true,
		});
		this.state = {
			...this.state,
			maxConsecutiveErrors: 5,
			stopOnConsecutiveErrors: true,
		};
	}

	getTestName = () => {
		const {testKeyType = null} = this.props;
		const isAdultFollowup = testKeyType === 'adult-followup';
		return isAdultFollowup ? strings.sp_testnameAdult : strings.sp_testname;
	};
	updateTimeUsed = (timeUsed) => {
		const skipTime = this.state.skipTime;

		if (skipTime === timeUsed) {
			const newSkipTime = 30 + timeUsed;
			this.setState({
				timeElapsedLasAnsnwer: timeUsed,
				timeUsed: timeUsed,
				skipTime: newSkipTime,
			});
			this.answerWrong();
		} else {
			this.setState({
				timeUsed: timeUsed,
				timeElapsedLasAnsnwer: timeUsed,
			});
		}
	};

	handleKeyPress = (event) => {
		const {
			options: {limitHotkeysToTest, enableHotkeys},
			currentStage,
		} = this.state;

		if ((!limitHotkeysToTest || currentStage === 0) && enableHotkeys) {
			if (event.key === 'a') {
				this.answer(2);
			}
			if (event.key === 's') {
				this.answer(1);
			}
			if (event.key === 'd') {
				this.answer(0);
			}
		} else if (
			(!limitHotkeysToTest || currentStage === 1) &&
			enableHotkeys
		) {
			if (
				event.key === 'a' &&
				this.state.timeElapsedLasAnsnwer + 30 !== this.state.skipTime
			) {
				const skipTime = 30 + this.state.timeElapsedLasAnsnwer;
				this.setState({skipTime});
				this.answerCorrect(2);
				this.handleCountdownComplete();
			}
			if (
				event.key === 's' &&
				this.state.timeElapsedLasAnsnwer + 30 !== this.state.skipTime
			) {
				const skipTime = 30 + this.state.timeElapsedLasAnsnwer;
				this.setState({skipTime});
				this.answerCorrect(1);
				this.handleCountdownComplete();
			}
			if (
				event.key === 'd' &&
				this.state.timeElapsedLasAnsnwer + 30 !== this.state.skipTime
			) {
				const skipTime = 30 + this.state.timeElapsedLasAnsnwer;
				this.setState({skipTime});
				this.answerWrong();
				this.handleCountdownComplete();
			}
		}
	};
	answer = (numberOfCorrect) => {
		if (numberOfCorrect === 2) {
			updateStepData({
				answered: true,
				correct: true,
				feedbackDone: false,
			});
		} else {
			updateStepData({
				answered: true,
				correct: false,
				feedbackDone: false,
			});
		}
	};
	handleCountdownComplete = () => {
		this.setState((prevState) => ({
			key: prevState.key < 20 ? prevState.key + 1 : 1,
		}));
	};

	componentWillReceiveProps(newProps) {
		super.componentWillReceiveProps(newProps);

		if (
			newProps.stepData.feedbackDone &&
			!this.props.stepData.feedbackDone &&
			newProps.stepData.answered
		) {
			this.answerCorrect();
		}
	}

	getTask = (currentStep) => {
		const {testKeyType = null} = this.props;
		const isAdultFollowup = testKeyType === 'adult-followup';
		return isAdultFollowup
			? getSpoonerismAdult().getIntroSteps()[currentStep].task
			: getSpoonerism().getIntroSteps()[currentStep].task;
	};
	getCorrect = (currentStep) => {
		const {testKeyType = null} = this.props;
		const isAdultFollowup = testKeyType === 'adult-followup';
		return isAdultFollowup
			? getSpoonerismAdult().getIntroSteps()[currentStep].correct
			: getSpoonerism().getIntroSteps()[currentStep].correct;
	};

	renderIntro = () => {
		const {currentStep, candidateReady} = this.state;
		const {testKeyType = null} = this.props;
		const isAdultFollowup = testKeyType === 'adult-followup';
		return (
			<Fragment>
				{currentStep === 0 && (
					<Fragment>
						<p>
							{strings.formatString(
								isAdultFollowup
									? strings.sp_admin1_adult
									: strings.sp_admin1,
								<i>{strings.sp_example1}</i>
							)}
						</p>
						<p>
							{isAdultFollowup
								? strings.sp_admin2_adult
								: strings.sp_admin1part2}
						</p>
						<AdminReadyButton
							isPractiseTasks
							remoteIsReady={candidateReady}
							onClick={this.props.nextStep}
							testKeyType={testKeyType}
						/>
					</Fragment>
				)}
				{currentStep > 0 && currentStep < 4 && (
					<Fragment>
						<p>{strings.practiceTasks}</p>

						<p>
							{strings.formatString(
								strings.taskNum,
								this.getTask(currentStep)
							)}
						</p>

						<p>
							{strings.formatString(
								strings.expectedAnswer,
								this.getCorrect(currentStep)
							)}
						</p>

						{isAdultFollowup && (
							<>
								<>
									<p>{strings.sp_admin3_adult}</p>
									<p>
										{strings.formatString(
											strings.sp_admin4_adult,
											this.getCorrect(currentStep)
										)}
									</p>
								</>
							</>
						)}
						<button
							disabled={this.props.stepData.answered}
							onClick={(e) => {
								e.stopPropagation();
								this.answer(2);
							}}
						>
							{strings.sp_2correct}
						</button>
						<button
							disabled={this.props.stepData.answered}
							onClick={(e) => {
								e.stopPropagation();
								this.answer(1);
							}}
						>
							{strings.sp_1correct}
						</button>
						<button
							disabled={this.props.stepData.answered}
							onClick={(e) => {
								e.stopPropagation();
								this.answer(0);
							}}
						>
							{strings.sp_bothWrong}
						</button>
					</Fragment>
				)}
				{currentStep === 4 && (
					<Fragment>
						<p>
							{isAdultFollowup
								? strings.sp_admin5_adult
								: strings.sp_admin2}
						</p>
						<p>
							{isAdultFollowup
								? strings.sp_admin6_adult
								: strings.clickStartWhenReady}
						</p>
						<AdminReadyButton
							remoteIsReady={candidateReady}
							onClick={this.props.nextStage}
							testKeyType={testKeyType}
						/>
					</Fragment>
				)}
			</Fragment>
		);
	};

	renderTest = () => {
		const {currentStep} = this.state;
		const {testKeyType = null} = this.props;
		const isAdultFollowup = testKeyType === 'adult-followup';
		const steps = isAdultFollowup
			? getSpoonerismAdult().getSteps()
			: getSpoonerism().getSteps();
		return (
			<div>
				<div className="lit-stop-watch-div">
					<StopWatch autoStart integer onTick={this.updateTimeUsed} />
				</div>
				<p>
					{isAdultFollowup
						? strings.sp_admin_listen_adult
						: strings.sp_admin_listen}
					{!isAdultFollowup && (
						<>
							<br />
							{strings.hotkeyDescSpoonerism}
							<br />
							{strings.hotkeyCorrectSpoonerism}
							<br />
							{strings.hotkeyWrongSpoonerism}
						</>
					)}

					{isAdultFollowup && (
						<>
							<br />
							{strings.hotkeyCorrect}<br />
							{strings.hotkeyWrong}<br />
							{strings.hotkeyUnanswered}
						</>
					)}
				</p>
				<p>
					{strings.formatString(
						strings.taskNumOf,
						currentStep + 1,
						steps.length
					)}
				</p>
				<p>
					{strings.formatString(
						strings.taskNum,
						steps[currentStep].task
					)}
				</p>
				<p>
					{strings.formatString(
						strings.expectedAnswer,
						<b>{steps[currentStep].correct}</b>
					)}
				</p>
				<div className="lit-all-buttons-div">
					<button
						disabled={
							this.state.timeElapsedLasAnsnwer + 30 ===
							this.state.skipTime
						}
						onClick={(e) => {
							e.stopPropagation();
							const skipTime =
								30 + this.state.timeElapsedLasAnsnwer;
							this.setState({skipTime});
							this.answerCorrect(2);
							this.handleCountdownComplete();
						}}
					>
						{strings.sp_2correct}
					</button>
					<button
						disabled={
							this.state.timeElapsedLasAnsnwer + 30 ===
							this.state.skipTime
						}
						onClick={(e) => {
							e.stopPropagation();
							const skipTime =
								30 + this.state.timeElapsedLasAnsnwer;
							this.setState({skipTime});
							this.answerCorrect(1);
							this.handleCountdownComplete();
						}}
					>
						{strings.sp_1correct}
					</button>
					<button
						disabled={
							this.state.timeElapsedLasAnsnwer + 30 ===
							this.state.skipTime
						}
						onClick={(e) => {
							e.stopPropagation();
							const skipTime =
								30 + this.state.timeElapsedLasAnsnwer;
							this.setState({skipTime});
							this.answerWrong();
							this.handleCountdownComplete();
						}}
					>
						{strings.sp_bothWrong}
					</button>
					<div className="lit-count-down-div">
						{this.state.timeElapsedLasAnsnwer + 30 !==
							this.state.skipTime && (
							<CountDown
								key={this.state.key}
								duration={30}
								onComplete={this.handleCountdownComplete}
							/>
						)}
					</div>
				</div>
			</div>
		);
	};

	renderWaiting = () => {
		const {testKeyType = null} = this.props;
		const isAdultFollowup = testKeyType === 'adult-followup';
		return (
			<div>
				<p>
					{strings.formatString(
						isAdultFollowup
							? strings.testDoneAdult4
							: strings.testDone,
						isAdultFollowup
							? strings.sp_testnameAdult
							: strings.sp_testname
					)}
				</p>
				<Fragment>
					<button onClick={this.props.nextStage}>
						{strings.getLanguage() === 'de'
							? 'Nächste'
							: strings.nextTest}
					</button>
				</Fragment>
			</div>
		);
	};
}

export default SpoonerismAdmin;
